import api from "../../services/api";

export const exportToExcel = async ({ dateFrom, dateTo, userId, status }) => {
  try {
    const params = { dateFrom, dateTo };
    if (userId) params.userId = userId;
    if (status) params.status = status;

    const response = await api.get("/reports/export-excel", {
      params,
      responseType: "blob",
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `Reporte_WhatsApp_${dateFrom}_${dateTo}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Error exporting Excel:", err);
  }
};

export const exportToPDF = async ({ dateFrom, dateTo, userId, status }) => {
  try {
    const params = { dateFrom, dateTo };
    if (userId) params.userId = userId;
    if (status) params.status = status;

    const response = await api.get("/reports/export-pdf", {
      params,
      responseType: "blob",
    });

    const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `Reporte_WhatsApp_${dateFrom}_${dateTo}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Error exporting PDF:", err);
  }
};
